var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component-span> <span ng-if=\"$ctrl.number > 0\" class=\"winres-shopping-cart-indicator {{ $ctrl.animationState }}\" style=\"cursor: pointer\"> {{ $ctrl.number }} </span> </web-component-span>";
var id1="winresShoppingCartIndicator.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresShoppingCartIndicator/winresShoppingCartIndicator.html
// module id = 444
// module chunks = 2